import {
  confirmSignUp,
  fetchAuthSession,
  resendSignUpCode,
  signIn,
  signOut,
  signUp,
  type SignInInput,
} from "aws-amplify/auth";
import store from "../store";
import { AUTHENTICATION_INITIAL, AUTHENTICATION_UPDATE } from "../store/slices/authenticationSlice";
import { UserInstance } from "./userClass";

class AuthenticationClass {
  private initial = AUTHENTICATION_INITIAL;
  private verificationId: string | null = null;

  public getCurrentSession = async () => {
    try {
      const session = await fetchAuthSession();

      if (!session.tokens) return;
      // console.log('session', session.tokens?.accessToken.toString());

      localStorage.setItem("authToken", session.tokens?.accessToken.toString());

      const user = {
        token: session.tokens?.accessToken.toString(),
        sub: session.userSub,
      };
      // console.log('TOKEN BE', user.token);
      return user;
    } catch (error) {
      console.error("error getting current session", error);
    }
  };

  public handleSendVerificationCode = async (username: string) => {
    return resendSignUpCode({ username });
  };

  public handleVerify = async (username: string, confirmationCode: string) =>
    confirmSignUp({ username, confirmationCode });

  public handleSignIn = async (credentials: SignInInput) => {
    try {
      const { isSignedIn, nextStep } = await signIn({
        ...credentials,
        options: {
          autoSignIn: true,
        },
      });

      console.log({
        isSignedIn,
        nextStep,
      });

      if (nextStep.signInStep) {
        store.dispatch(
          AUTHENTICATION_UPDATE({
            data: {
              nextStep: nextStep.signInStep,
            },
          }),
        );
      }

      if (isSignedIn) {
        const session = await this.getCurrentSession();

        if (!session?.token || !session.sub) return;

        const { token } = session;

        // Save token to localStorage
        localStorage.setItem("authToken", token);

        store.dispatch(
          AUTHENTICATION_UPDATE({
            data: {
              ...AUTHENTICATION_INITIAL,
              token,
            },
          }),
        );
      }

      return nextStep?.signInStep;
    } catch (error) {
      console.error("error signing in", error);
      throw error;
    }
  };

  public handleSignOut = async (reason: string | null = null) => {
    try {
      await signOut();

      localStorage.removeItem("authToken");
      localStorage.removeItem("activeBusiness");
      // clear local storage
      localStorage.clear();

      store.dispatch(
        AUTHENTICATION_UPDATE({
          data: {
            ...AUTHENTICATION_INITIAL,
            error: reason,
          },
        }),
      );
    } catch (error) {
      console.error("error signing out", error);
    }
  };

  public getError = () => {
    return store.getState().auth.error;
  };

  public handleRegister = async ({
    username,
    email,
    password,
    firstName,
    lastName,
    gender,
    dateOfBirth,
    referralCode,
    experienceId,
    agreedToMarketing,
  }: {
    username: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    gender: string;
    dateOfBirth: string;
    agreedToMarketing: boolean;
    referralCode?: string;
    experienceId?: number;
  }) => {
    const exists = await UserInstance.checkUserExists(username, email);

    if (exists) {
      throw new Error("User already exists with that username or email");
    }

    const user = await signUp({
      username,
      password,
      options: {
        userAttributes: {
          email,
          family_name: lastName,
          given_name: firstName,
        },
        autoSignIn: true,
      },
    });

    if (!user.userId) {
      throw new Error("Something went wrong");
    }

    const { userId } = user;

    await UserInstance.register({
      username,
      email,
      firstName,
      lastName,
      uid: userId,
      gender,
      dateOfBirth,
      referralCode,
      experienceId,
      agreedToMarketing,
    });
  };
}

const AuthenticationInstance = new AuthenticationClass();

export { AuthenticationInstance };
